// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"f86a40ff","656":"966d9175","801":"214800e9","816":"2ea66b6a"}[chunkId] + ".chunk.js";
};